import { render } from "./DropdownMenu.vue?vue&type=template&id=16792803&scoped=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=16792803&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16792803"]])

export default __exports__